var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    this.$store.getters.isLoggedIn === true
      ? _c("div", [_c("user-menu")], 1)
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "main-wrapper signin-form center" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("h1", { staticClass: "text-align-center margin-bottom-35" }, [
        _vm._v("Access Denied")
      ]),
      _vm._v(" "),
      this.$store.getters.isLoggedIn === true
        ? _c(
            "div",
            { staticClass: "text-align-right" },
            [
              _c("router-link", { attrs: { to: _vm.url } }, [
                _vm._v("-- Go to Dashboard")
              ])
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "text-align-right" },
            [
              _c("router-link", { attrs: { to: "/login" } }, [
                _vm._v("-- Go to Login")
              ])
            ],
            1
          )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "text-align-center margin-bottom-20 mm-logo" },
      [_c("img", { attrs: { src: require("@/assets/MM-logo.png") } })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d55c80ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d55c80ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forbidden.vue
// module id = null
// module chunks = 